// @import dependencies
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import { NotesAchievedModuleLayout } from 'app_components/modules/campus/academic/notesAchieved'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import storeService from 'app_services/storeService'
import CourseActivityService from 'app_services/campus/academic/courseActivityService'
// @end

// @import types
import { IMyCourse } from 'app_types/campus/academic/myCoursesTypes'
import { INote } from 'app_types/campus/academic/notesAchievedTypes'
// @end

// @ADD Component types
interface INotesAchievedModuleProps {
  id?: string
}
interface INotesAchievedModuleState {
  defaultStatus: boolean
  notesData: Array<INote>
  chartOptions: any
  status: 'loading' | 'error' | null
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => { return state }

class NotesAchievedModule extends Component<INotesAchievedModuleProps, INotesAchievedModuleState> {

  private courseActivityService: CourseActivityService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: INotesAchievedModuleProps) {
    super(props)
    this.state = {
      defaultStatus: false,
      notesData: [],
      chartOptions: {},
      status: 'loading'
    }

    this.courseActivityService = new CourseActivityService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    storeService?.subscribe('courses.courseSelected', this.fetchNotesAchieved)
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {
    storeService?.unsubscribe('courses.courseSelected', this.fetchNotesAchieved)
  }

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => { }

  // @Add custom methods

  fetchNotesAchieved = async (data: IMyCourse | null) => {
    this.setState({ status: 'loading', notesData: [] })

    if (data?._id) {

      const dataResponse = await this.courseActivityService.fetchNotesAchieved(
        {
          courseID: data?._id
        });


      if (dataResponse && dataResponse.grades) {

        const grades = dataResponse.grades.reduce((accum: Array<any>, element) => {
          const progress = element.graderaw || 0
          let progressExtra: any = {
            pathColor: undefined,
            textColor: '#7C878E'
          }
          if (progress > 0) {
            if (progress < 70) {
              progressExtra.pathColor = 'red'
              progressExtra.textColor = 'red'
            } else {
              progressExtra.pathColor = '#3e98c7'
              progressExtra.textColor = '#3e98c7'
            }
          }
          accum.push({
            id: element.id,
            title: element.name,
            cmid: element.cmid,
            value: element.graderaw,
            progress: {
              value: progress,
              pathColor: progressExtra.pathColor,
              textColor: progressExtra.textColor,
            },
            grademin: element.grademin,
            grademax: element.grademax

          });
          return accum;

        }, [])

        const sortedGrades = grades?.sort(({ title: a }, { title: b }) => {
          const num1 = parseInt(a.split(" ")[0]) || Infinity;
          const num2 = parseInt(b.split(" ")[0]) || Infinity;

          if (num1 !== num2) {
            return num1 - num2;
          } else {
            return a.localeCompare(b);
          }
        })

        this.setState({ notesData: sortedGrades, status: null });
      } else {
        this.setState(({ status: null }))
      }
    } else {
      this.setState(({ status: null }))
    }
  }

  render() {
    return (
      <NotesAchievedModuleLayout
        defaultStatus={this.state.defaultStatus}
        status={this.state.status}
        notesData={this.state.notesData}
        chartOptions={this.state.chartOptions}
        id={this.props.id}
      />
    )
  }
}

export default connect(mapStatesToProps)(NotesAchievedModule)
